import axiosClient from "../../../api/apiClient";

interface IOptions {
    domain?: string|null;
    token?: string|null;
}

export const APIPostClientLogin = (options: IOptions) => {
    return axiosClient.get(`/login/client?domain=${options.domain}&token=${options.token}`);
};